export var FieldType;
(function (FieldType) {
    FieldType["None"] = "-";
    FieldType["Symbol"] = "S";
    FieldType["Token"] = "N";
    FieldType["CacheKey"] = "K";
    FieldType["Context"] = "#";
    FieldType["TimeStamp"] = "T";
    FieldType["Date"] = "D";
    FieldType["Sequence"] = "E";
    FieldType["Price"] = "P";
    FieldType["Capital"] = "L";
    FieldType["Quantity"] = "Q";
    FieldType["Volume"] = "V";
    FieldType["Count"] = "U";
    FieldType["Char"] = "C";
    FieldType["Integral"] = "I";
    FieldType["Float"] = "F";
    FieldType["String"] = "X";
    FieldType["Bitmask"] = "H";
    FieldType["Enum"] = "M";
    FieldType["Boolean"] = "B";
    FieldType["Index"] = "A";
    FieldType["Formula"] = "f";
    FieldType["Aggregate"] = "G";
})(FieldType || (FieldType = {}));
const fieldTypeNamesInitializer = Object.keys(FieldType).map((x) => [FieldType[x], x]);
export const FieldTypeNames = new Map(fieldTypeNamesInitializer);
Object.seal(FieldTypeNames);
export const RowField = Symbol('row');
export const RowIdField = Symbol('row-id');
export var SortOrder;
(function (SortOrder) {
    SortOrder["ascending"] = "ascending";
    SortOrder["descending"] = "descending";
})(SortOrder || (SortOrder = {}));
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["disconnected"] = "disconnected";
    ConnectionStatus["connected"] = "connected";
})(ConnectionStatus || (ConnectionStatus = {}));
export var AuthStatus;
(function (AuthStatus) {
    AuthStatus["uninitialized"] = "uninitialized";
    AuthStatus["badToken"] = "bad-token";
    AuthStatus["authenticated"] = "authenticated";
})(AuthStatus || (AuthStatus = {}));
//# sourceMappingURL=models.js.map